import { BreakpointService } from '@/common/services/breakpoint/breakpoint.service';
import { UrlService } from '@/common/services/url/url.service';
import { isValid } from '@/common/utils/validation/common.utils';
import { LocationDetailsResponse } from '@/core/domain/location-details/models/location-details.model';
import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';

@Component({
    selector: 'fe-destination-airport',
    templateUrl: './destination-airport.component.html',
    styleUrls: ['./destination-airport.component.scss'],
})
export class DestinationAirportComponent {
    public destinationTitle: string | null = null;
    public destinationDescription: string | null = null;
    public destinationDescriptionExtra: string | null = null;
    public selectedImage: string | null = null;
    public defaultImage = 'images/atencionclientebaner.jpg';

    constructor(
        private route: ActivatedRoute,
        private translate: TranslateService,
        private title: Title,
        private meta: Meta,
        private url: UrlService,
        private router: Router,
        public breakpoint: BreakpointService,
    ) {}

    onLocationDetailsLoaded(locationDetails: LocationDetailsResponse): void {
        if (!isValid(locationDetails)) {
            this.router.navigateByUrl(this.url.format(''), {
                replaceUrl: true,
            });
        }
        const destination = locationDetails.data?.destination;
        this.destinationTitle = destination
            ? destination.branchName
            : 'Destination not found';
        this.destinationDescription = destination?.description || null;
        this.destinationDescriptionExtra =
            destination?.descriptionExtra || null;
        const imgHorizontal = destination?.horizontalImage;
        const imgVertical = destination?.verticalImage;

        this.selectedImage = this.breakpoint.isMobile()
            ? imgVertical || null
            : imgHorizontal || null;
    }
}
